import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-monster-pumpkin transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90 text-base",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 text-sm",
        outline:
          "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground text-sm",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80 text-sm",
        ghost: "hover:bg-accent hover:text-accent-foreground text-sm",
        link: "text-primary underline-offset-4 hover:underline text-sm",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, tooltip, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  
  // Note: tooltip prop is accepted but ignored to maintain API compatibility
  // Use TooltipButton component for tooltip functionality
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  );
})
Button.displayName = "Button"

// Explicit named export - ensure it's not tree-shaken
export { Button, buttonVariants }
// Default export for compatibility  
export default Button
